import React from 'react';
import { SiteComponent } from '../SiteComponentPlugin';
import { AssignEntityWarning } from './AssignEntityPlugin';
import { SiteCard, SiteCardConfigurator } from './SiteCardPlugin';
export const AssignEntityCard = props => {
    return (React.createElement(SiteComponent, Object.assign({ plugin: AssignEntityCardPlugin }, props),
        React.createElement(SiteCard, Object.assign({}, props))));
};
export const AssignEntityCardConfigurator = props => {
    return (React.createElement(React.Fragment, null,
        React.createElement(AssignEntityWarning, { component: props.component }),
        React.createElement(SiteCardConfigurator, Object.assign({}, props))));
};
export const AssignEntityCardPlugin = {
    name: 'Assign Entity Card',
    type: 'assign-entity-card',
    component: AssignEntityCard,
    configurator: AssignEntityCardConfigurator,
    slots: [
        { name: 'Table', type: 'table', slot: 'table' },
        {
            name: 'Card Actions',
            type: 'assign-entity-card-actions',
            slot: 'actions'
        }
    ]
};
//# sourceMappingURL=AssignEntityCardPlugin.js.map